export enum FileUploadType {
  AnthemImport = 1,
  CareCompassImport = 2,
  ElevanceGroupImport = 4
}
